import { useEnvironment } from "~/context/EnvironmentContext";

const Column = () => {
  // コンテキストから静的画像バケットのエンドポイントを取得
  const { staticImageBucketEndpoint } = useEnvironment();

  return (
    <section className="my-12 md:my-20 px-4 md:my-[104px] md:px-7">
      <div className="md:max-w-[1040px] md:mx-auto">
        <div className="md:mb-6 mb-4 flex items-center justify-between">
          <h2 className="sp:w-full text-2xl text-center font-black leading-normal md:text-left md:text-[32px] md:leading-normal">転職活動のノウハウ</h2>
          <a href="https://fjob-kyujin.com/column" className="flex items-center gap-2 sp:hidden md:hover:text-primary md:hover:fill-primary">
            <span className="font-medium text-sm leading-[1.8] md:leading-normal">
              記事をもっと見る
            </span>
            <svg className="w-2.5 h-2.5 md:w-[13px]">
              <use xlinkHref="/symbol-defs.svg#icon-chevron-right"></use>
            </svg>
          </a>
        </div>
        <ul className="flex md:flex-row md:flex-wrap md:gap-4 gap-2 flex-col md:[&_li]:w-[calc(50%-8px)] md:[&_li]:p-4 [&_li]:p-2 [&_li]:border-faint [&_li]:border-[1px] [&_li]:rounded md:[&_li:hover]:bg-[rgba(222,222,222,0.20);] [&_a]:flex [&_a]:items-center md:[&_a]:gap-4 [&_a]:gap-3 sp:[&_figure]:w-[80px] sp:[&_figure]:h-[53px] [&_p]:flex-1 [&_p]:font-medium [&_p]:text-sm">
          <li>
            <a href="https://fjob-kyujin.com/column/inshoku-kyujin-erabikata">
              <figure>
                <img
                  src={`${staticImageBucketEndpoint}/public/top/column/top-column-thumb01.webp`}
                  width="120"
                  height="80"
                  alt=""
                />
              </figure>
              <p>
                飲食求人の選び方ガイド！後悔しない職場の見つけ方とチェックポイント
              </p>
              <svg className="w-2.5 h-2.5 md:w-[13px] sp:mr-1">
                  <use xlinkHref="/symbol-defs.svg#icon-chevron-right"></use>
                </svg>
            </a>
          </li>
          <li>
            <a href="https://fjob-kyujin.com/column/innsyokuten-mensetsu">
              <figure>
                <img
                  src={`${staticImageBucketEndpoint}/public/top/column/top-column-thumb02.webp`}
                  width="120"
                  height="80"
                  alt=""
                />
              </figure>
              <p>
                飲食店面接で採用を勝ち取る！よく聞かれる質問と志望動機の答え方
              </p>
               <svg className="w-2.5 h-2.5 md:w-[13px] sp:mr-1">
                  <use xlinkHref="/symbol-defs.svg#icon-chevron-right"></use>
                </svg>
            </a>
          </li>
          <li>
            <a href="https://fjob-kyujin.com/column/inshoku-rirekisho-kakikata">
              <figure>
                <img
                  src={`${staticImageBucketEndpoint}/public/top/column/top-column-thumb03.webp`}
                  width="120"
                  height="80"
                  alt=""
                />
              </figure>
              <p>
                飲食業界の履歴書：採用担当者の目に留まる書き方
              </p>
              <svg className="w-2.5 h-2.5 md:w-[13px] sp:mr-1">
                <use xlinkHref="/symbol-defs.svg#icon-chevron-right"></use>
              </svg>
            </a>
          </li>
          <li>
            <a href="https://fjob-kyujin.com/column/inshoku-enman-taishoku">
              <figure>
                <img
                  src={`${staticImageBucketEndpoint}/public/top/column/top-column-thumb04.webp`}
                  width="120"
                  height="80"
                  alt=""
                />
              </figure>
              <p>
                飲食店を円満退職するための完全ガイド｜不安を解消し次のキャリアへ進む方法
              </p>
               <svg className="w-2.5 h-2.5 md:w-[13px] sp:mr-1">
                  <use xlinkHref="/symbol-defs.svg#icon-chevron-right"></use>
                </svg>
            </a>
          </li>
        </ul>
        <a href="https://fjob-kyujin.com/column" className="mt-4 flex items-center justify-center gap-2 md:hidden">
            <span className="font-medium text-sm leading-[1.8] md:leading-normal">
              記事をもっと見る
            </span>
            <svg className="w-2.5 h-2.5 md:w-[13px] md:mr-1">
              <use xlinkHref="/symbol-defs.svg#icon-chevron-right"></use>
            </svg>
          </a>
      </div>
    </section>
  );
};

export default Column;
